import React from 'react';

interface CircleProps {
  cx: number;
  cy: number;
  r: number;
  fill?: string;
  stroke?: string;
}

interface CircleIconProps {
  width?: number;
  height?: number;
  viewBox?: string;
  circles: CircleProps[];
}

export const CircleIcon: React.FC<CircleIconProps> = ({
  width = 19,
  height = 19,
  viewBox = '0 0 19 19',
  circles,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox={viewBox}
    fill="none"
  >
    {circles.map((c, idx) => (
      <circle key={idx} cx={c.cx} cy={c.cy} r={c.r} fill={c.fill} stroke={c.stroke} />
    ))}
  </svg>
);
